import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'

export default {
  aboutBatteryHealth: {
    id: 'product_jp_about_battery_health_updated',
    defaultMessage: 'About battery health',
  },
  bodyHeading: {
    id: 'product_jp_about_battery_modal_updated_body_heading',
    defaultMessage: 'Choose your battery capacity',
  },
  description: {
    id: 'product_jp_about_battery_modal_updated_description',
    defaultMessage:
      'Electronic devices like smartphones and laptops can experience battery wear over time, especially with frequent charging or use while charging, which leads to a decrease in battery capacity. At Back Market, we offer three battery options to match your needs.',
  },
  batteryTier1Title: {
    id: 'product_jp_about_battery_modal_updated_tier1_title',
    defaultMessage: '80% ~ 89%',
  },
  batteryTier1Description: {
    id: 'product_jp_about_battery_modal_updated_tier1_description',
    defaultMessage:
      'Sufficient for everyday use. Recommended for price-conscious customers.',
  },
  batteryTier2Title: {
    id: 'product_jp_about_battery_modal_updated_tier2_title',
    defaultMessage: '90% ~ 99%',
  },
  batteryTier2Description: {
    id: 'product_jp_about_battery_modal_updated_tier2_description',
    defaultMessage:
      'Best value! Perfect for customers who want a balance of price and performance.',
  },
  batteryTier3Title: {
    id: 'product_jp_about_battery_modal_updated_tier3_title',
    defaultMessage: '100% (New)',
  },
  batteryTier3Description: {
    id: 'product_jp_about_battery_modal_updated_tier3_description',
    defaultMessage:
      'Brand-new battery capacity. Recommended for those who want to use their device without worrying about charging.',
  },
  infoContent: {
    id: 'product_jp_about_battery_modal_updated_info_content',
    defaultMessage:
      'An iPhone 13 Pro with 80% battery capacity can stream video for up to 16.5 hours. With an excellent battery (90%+), that increases to 18.5 hours, and with a new battery, up to 20 hours.',
  },
  infoTitle: {
    id: 'product_jp_about_battery_modal_updated_info_title',
    defaultMessage: 'Estimated Usage Based on Battery Capacity:',
  },
  learnMore: {
    id: 'product_jp_about_battery_updated_learn_more',
    defaultMessage: 'Learn more',
  },
} as Record<string, I18nDefinition>
